/** Quote Builder PRO — domain types (Sprint 2.3) */

export type QuoteBlockType =
  | 'product'
  | 'service'
  | 'labor'
  | 'note'
  | 'warranty'
  | 'discount'
  | 'subtotal'
  | 'separator'
  | 'title'
  | 'image'

export type QuoteItemOrigin =
  | 'comparison'
  | 'service_catalog'
  | 'template'
  | 'system'

export type QuoteProStatus = 'DRAFT' | 'READY' | 'SENT' | 'APPROVED' | 'ARCHIVED'

export type QuoteSidebarCategory =
  | 'Desktop'
  | 'Notebook'
  | 'Servidor'
  | 'Rede'
  | 'Monitor'
  | 'Impressora'
  | 'Periféricos'
  | 'Serviços'
  | 'Favoritos'
  | 'Histórico'

export interface QuoteItemOriginMeta {
  source: QuoteItemOrigin
  /** Required for products — Product Intelligence / comparison product id */
  productId: string
  fingerprint?: string
  supplierId?: string
  supplierName?: string
  comparisonOfferId?: string
}

export interface QuoteBlock {
  id: string
  type: QuoteBlockType
  origin: QuoteItemOriginMeta
  description: string
  quantity: number
  purchasePrice: number
  salePrice: number
  margin: number
  profit: number
  discountPercent: number
  discountValue: number
  position: number
  groupId?: string
  meta?: Record<string, string>
}

export interface QuoteTotals {
  quantity: number
  purchaseTotal: number
  saleTotal: number
  profitTotal: number
  marginPercent: number
  discountTotal: number
  total: number
}

export interface QuoteDocumentPro {
  id: string
  customerId: string | null
  title: string
  status: QuoteProStatus
  globalMarginPercent: number | null
  globalDiscountPercent: number
  globalDiscountValue: number
  blocks: QuoteBlock[]
  totals: QuoteTotals
  createdAt: string
  updatedAt: string
}

export interface QuoteServiceDefinition {
  id: string
  label: string
  defaultSalePrice: number
  defaultPurchasePrice: number
  category: 'Serviços'
}

export interface QuoteTemplateDefinition {
  id: string
  name: string
  category: QuoteSidebarCategory
  blocks: Array<{
    type: QuoteBlockType
    description: string
    productId: string
    origin: QuoteItemOrigin
    purchasePrice?: number
    salePrice?: number
    quantity?: number
    fingerprint?: string
  }>
}

export interface QuoteExportPayload {
  ok: true
  format: 'pdf' | 'pdf-meta' | 'json'
  quoteId: string
  title: string
  totals: QuoteTotals
  itemCount: number
  message: string
  generatedAt: string
  filename?: string
  bytes?: Uint8Array
}

export interface ComparisonProductSource {
  productId: string
  fingerprint: string
  description: string
  purchasePrice: number
  salePrice: number
  supplierId: string
  supplierName: string
  comparisonOfferId: string
  category?: string
}

export const SERVICE_CATALOG: QuoteServiceDefinition[] = [
  { id: 'svc:instalacao', label: 'Instalação', defaultSalePrice: 150, defaultPurchasePrice: 0, category: 'Serviços' },
  { id: 'svc:configuracao', label: 'Configuração', defaultSalePrice: 120, defaultPurchasePrice: 0, category: 'Serviços' },
  { id: 'svc:backup', label: 'Backup', defaultSalePrice: 200, defaultPurchasePrice: 0, category: 'Serviços' },
  { id: 'svc:migracao', label: 'Migração', defaultSalePrice: 350, defaultPurchasePrice: 0, category: 'Serviços' },
  { id: 'svc:formatacao', label: 'Formatação', defaultSalePrice: 180, defaultPurchasePrice: 0, category: 'Serviços' },
  { id: 'svc:limpeza', label: 'Limpeza', defaultSalePrice: 100, defaultPurchasePrice: 0, category: 'Serviços' },
  { id: 'svc:montagem', label: 'Montagem', defaultSalePrice: 220, defaultPurchasePrice: 0, category: 'Serviços' },
  { id: 'svc:treinamento', label: 'Treinamento', defaultSalePrice: 400, defaultPurchasePrice: 0, category: 'Serviços' },
  { id: 'svc:visita', label: 'Visita Técnica', defaultSalePrice: 180, defaultPurchasePrice: 0, category: 'Serviços' },
]
